// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"books_scrollbar__2iB9w"};